export default context => {
  // Replace with your VK retargeting ID
  const VK_RETARGETING_ID = context.$config.vkRetargetingId

  // Prevent multiple script inserts
  if (window.VK && window.VK.Retargeting) {
    window.VK.Retargeting.Init(VK_RETARGETING_ID)
    window.VK.Retargeting.Hit()
    return
  }

  // Dynamically load the VK script
  const script = document.createElement('script')
  script.type = 'text/javascript'
  script.async = true
  script.src = 'https://vk.com/js/api/openapi.js?169'

  script.onload = () => {
    if (window.VK && window.VK.Retargeting) {
      window.VK.Retargeting.Init(VK_RETARGETING_ID)
      window.VK.Retargeting.Hit()
    }
  }

  document.head.appendChild(script)
}
